module.exports = __webpack_public_path__ + "img/SES_205420990.8d30518a.jpg";